var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRocketIcon = function SvgRocketIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#rocket-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "rocket-icon_svg__b",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0V0Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#rocket-icon_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    fillRule: "evenodd",
    d: "M3.186 14.66C.346 15.28.93 17.816.422 19.578c1.762-.509 4.298.076 4.918-2.764-.888.791-1.644 1.38-3.09.935-.443-1.445.145-2.201.936-3.089Zm12.22-10.067a2.086 2.086 0 1 1-2.95 2.95 2.086 2.086 0 0 1 2.95-2.95ZM8.012 20c.343-1.715.35-3.094.206-4.321-.528.242-1.635.823-2.258.2l-.919-.919-.919-.92c-.623-.622-.042-1.729.2-2.257-1.227-.144-2.606-.137-4.321.206.736-2.076 1.978-3.875 2.783-4.388 1.441-.916 2.834-1.054 3.983-.972C9.648 2.606 14.222-.857 19.812.189c1.045 5.589-2.419 10.163-6.44 13.044.08 1.15-.057 2.543-.974 3.983-.512.806-2.311 2.049-4.387 2.784Z",
    clipRule: "evenodd"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "rocket-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgRocketIcon;